import style from "./card_text_over-Image.module.scss";

import ImageComponent from "../image_component";
import CardTextOnly from "../card_text_only";

function CardTextOverImage({ image, text, alt, headerType }) {
  return (
    <div className={style.card_text_over_image}>
      <div className={style.overlay_bg} />
      <ImageComponent
        image={image}
        objectFit="cover"
        imageSize="serviceCardSize"
        alt={alt}
      />
      <CardTextOnly title={text} headerType={headerType} />
    </div>
  );
}

export default CardTextOverImage;
